import { descriptionUI } from 'platform/forms-system/src/js/web-component-patterns';
import VeteranInformationDescription from '../../components/FormDescriptions/VeteranInformationDescription';
import {
  blankSchema,
  DEFAULT_TITLE_OPTS,
  titleWithRoleUI,
} from '../../definitions';
import content from '../../locales/en/content.json';

const TITLE_TEXT = content['sponsor--chapter-overview-title'];

export default {
  uiSchema: {
    ...titleWithRoleUI(TITLE_TEXT, null, DEFAULT_TITLE_OPTS.sponsor),
    ...descriptionUI(VeteranInformationDescription),
  },
  schema: blankSchema,
};
